import { enqueueSnackbar } from 'notistack';
import sanitize from 'sanitize-filename';

import { DOCX } from '../models/Resource';

export const downloadFile = async (file) => {
  try {
    const isDocxFile = file.originalType === DOCX;

    const downloadedFile = await fetch(file.downloadLink);
    const blobFile = await downloadedFile.blob();

    const aElement = document.createElement('a');
    aElement.setAttribute('download', `${file.fileName}${isDocxFile ? '.docx' : ''}`);
    const href = URL.createObjectURL(blobFile);
    aElement.href = href;
    aElement.setAttribute('target', '_blank');
    aElement.click();
    URL.revokeObjectURL(href);
  } catch (error) {
    enqueueSnackbar('Sorry. Unable to download file', { autoHideDuration: 6 * 1000, variant: 'error' });
  }
};

export const bytesToMegaBytes = (bytes) => bytes / (1024 * 1024);
export const megaBytesToBytes = (mb) => mb * (1024 * 1024);
export const gigaBytesToBytes = (gb) => gb * megaBytesToBytes(1024);

export const sanitizeFileName = (file) =>
  new File([file], sanitize(file.name), {
    type: file.type,
  });

export default downloadFile;
